module.exports = __webpack_public_path__ + "static/media/kayden-kross-win.6305ff38.jpg";